import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { GetMiniTrackers, MiniTracker, MiniTrackerStateModel, NetworkMember, PatientEntity, SetStatus } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { EditTreatmentDialog, MinimalTrackable } from '../../components/edit-treatment-dialog/edit-treatment-dialog.component';

const moment = moment_;

@Component({
  selector: 'treatments',
  templateUrl: './treatments.component.html',
  styleUrls: ['./treatments.component.scss']
})
export class TreatmentsComponent implements OnInit {

  @Input() patient : PatientEntity;
  @Select(state => state.miniTrackerState) miniTrackerState$: Observable<MiniTrackerStateModel>;
  miniTrackerSubscription : Subscription;
  treatments : MiniTracker[];
  
  

  constructor(
    private store : Store,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.  miniTrackerSubscription  = this.miniTrackerState$.subscribe((miniTrackerState: MiniTrackerStateModel) => {
      console.log(miniTrackerState);
      if (miniTrackerState && miniTrackerState.miniTrackers) {
         this.treatments = miniTrackerState.miniTrackers.filter(t => t.trackableType === 'TREATMENT');
         this.treatments.sort((t1 : MiniTracker, t2 : MiniTracker) => {
            if (t1.status === 'ACTIVE' && t2.status === 'DISABLED') {
              return -1;
            }
            if (t2.status === 'ACTIVE' && t1.status === 'DISABLED') {
              return 1;
            }
            return t1.name.localeCompare(t2.name);
         });
      }
      console.log(this.treatments);   
    });
    console.log(this.patient);
    this.store.dispatch(new GetMiniTrackers(false, this.patient.username));

  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (fromPatient) {
      name = 'p';
      if (this.patient && this.patient.lastName) {
        name = this.patient.lastName;
      }
    }
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  toggleActive(treatment : MiniTracker) {
    let status : string = 'ACTIVE';
    if (treatment.status === 'ACTIVE') {
      status = 'DISABLED';
    }
    this.store.dispatch(new SetStatus(treatment.id, status)).subscribe(t => {
      this.store.dispatch(new GetMiniTrackers(false, this.patient.username));
    });
  }

  editTreatment(data : any) {
    console.log(data);
    let existing : MinimalTrackable[] = this.treatments.map((t : MiniTracker) =>  {
      return {
        id : t.id, 
        name : t.name, 
        status : t.status, 
        description : t.description, 
        username : this.patient.username,
        trackableType : t.trackableType 
      }
    });

    if (data === null) {
      //add
      data = {
        existing : existing,
        current : {
          username : this.patient.username
        }
      }
    } else {
      data = {
        existing : existing,
        current : {
          id : data.id,
          name: data.name,
          status: data.status,
          description: data.description,
          username: this.patient.username,
          trackableType: 'TREATMENT'
        }
      }
    }
    this.dialog.open(EditTreatmentDialog, {
      width: '600px',
      height: '400px',
      data: data
    });
  }
}